import React from "react";

import "./CartTotals.scss";

export interface ICartTotalLine {
  label: React.ReactNode;
  value?: string;
  pending?: boolean;
}

interface IProps {
  lines: ICartTotalLine[];
  totalLabel: string;
  totalValue: string;
  note?: string;
}

const CartTotals: React.FC<IProps> = (props) => {
  return (
    <div className="cartTotals">
      <div className="cartTotalsInner">
        {props.lines.map((line, index) => (
          <div className="line" key={index}>
            <span>{line.label}</span>
            {line.value !== undefined && (
              <span className={line.pending ? "pending" : undefined}>{line.value}</span>
            )}
          </div>
        ))}
        <div className="actual">
          <span>{props.totalLabel}</span>
          <span>{props.totalValue}</span>
        </div>
        {props.note && <div className="line note"><span>{props.note}</span></div>}
      </div>
    </div>
  );
};

export default CartTotals;
